import React,{useEffect,useMemo,useState}from'react';
import{createRoot}from'react-dom/client';
import{BrowserRouter}from'react-router-dom';
import{QueryClient,QueryClientProvider}from'@tanstack/react-query';
import{CssBaseline,ThemeProvider}from'@mui/material';
import{createRasanaTheme,loadAppearance,type RasanaAppearance}from'./theme';
import App from'./App';
const queryClient=new QueryClient({defaultOptions:{queries:{staleTime:15000,retry:1}}});
function RasanaRoot(){
 const[appearance,setAppearance]=useState<RasanaAppearance>(loadAppearance);
 useEffect(()=>{
  const sync=()=>setAppearance(loadAppearance());
  window.addEventListener('rasana-appearance-changed',sync);
  window.addEventListener('storage',sync);
  return()=>{window.removeEventListener('rasana-appearance-changed',sync);window.removeEventListener('storage',sync);};
 },[]);
 const theme=useMemo(()=>createRasanaTheme(appearance),[appearance]);
 return <ThemeProvider theme={theme}><CssBaseline/><QueryClientProvider client={queryClient}><BrowserRouter><App/></BrowserRouter></QueryClientProvider></ThemeProvider>;
}
createRoot(document.getElementById('root')!).render(<React.StrictMode><RasanaRoot/></React.StrictMode>);
